import script from "./GodApeQuestButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestButton.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestButton.vue?vue&type=style&index=0&id=02db3590&lang=scss"

const __exports__ = script;

export default __exports__